import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['The Complete Playbook (PDF)', 'Fillable Templates: Funding, Evidence, Review Maps', "Provider Tracker (so you don't 'lose' calls)", "Call Scripts Pack (first contact, follow-up, 'no spots')", 'NDIS Document Organizer (folder structure + file names)', 'One-Page NDIS Plan (your weekly board)'];
export function WhatsIncluded() {
  return <section className="py-20 bg-navy-900 text-white" data-id="element-130">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-133">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-134">
              What's inside (what you get today)
            </h2>
            <p className="text-gray-300 mb-8 text-lg" data-id="element-135">
              Everything you need to organize the chaos, pre-packaged so you
              don't have to think about structure.
            </p>

            <ul className="space-y-4" data-id="element-136">
              {items.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-center" data-id="element-137">
                  <div className="h-6 w-6 rounded-full bg-teal-500 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-138">
                    <Check className="h-4 w-4 text-white" data-id="element-139" />
                  </div>
                  <span className="text-lg text-gray-100" data-id="element-140">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative bg-white/5 rounded-2xl p-8 border border-white/10" data-id="element-141">
            {/* Abstract representation of the digital download */}
            <div className="aspect-[4/3] bg-gradient-to-br from-navy-800 to-navy-900 rounded-lg flex items-center justify-center relative overflow-hidden shadow-2xl" data-id="element-142">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-143">
                <div className="text-center" data-id="element-144">
                  <div className="text-teal-400 text-6xl font-serif mb-2" data-id="element-145">
                    4
                  </div>
                  <div className="text-white text-xl font-medium tracking-widest uppercase" data-id="element-146">
                    Maps
                  </div>
                </div>
              </div>
              {/* Decorative circles */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/20 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-147"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-purple-500/10 rounded-full blur-2xl -ml-10 -mb-10" data-id="element-148"></div>
            </div>
            <p className="text-center text-sm text-gray-400 mt-4" data-id="element-149">
              Digital Download • Instant Access
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}